import {Component, ViewChild, NgZone, ElementRef} from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  Content,
  AlertController,
  ToastController,
  LoadingController,
  ModalController, ViewController
} from "ionic-angular";
import {DatabaseProvider} from "../../providers/database/database";
import "rxjs/add/operator/mergeMap";
import {AuthProvider} from "../../providers/auth/auth";
import * as _ from 'lodash';
import * as moment from "moment";
import {AngularFirestore} from "@angular/fire/firestore";
import {Storage} from "@ionic/storage";
import {SignaturePad} from "angular2-signaturepad/signature-pad";
import {AngularFireStorage} from "@angular/fire/storage";
import {take} from "rxjs/operators";
import {PdfProvider} from "../../providers/pdf/pdf";
import {OrderProvider} from "../../providers/order/order";
import {UtilityProvider} from "../../providers/utility/utility";
import {Subject} from "rxjs";
import { PatientAddPage } from "../patient-add/patient-add";
import {PatientBatchPage} from "../patient-batch/patient-batch";
import {OrderDetailsPage} from "../order-details/order-details";
import { PatientsPage } from "../../pages/patients/patients";
import { ENV } from "@app/env";
import { Rx } from "models/rx";

@IonicPage()
@Component({
  selector: "page-orders",
  templateUrl: "orders.html"
})
export class OrdersPage {
  private ngUnsubscribe: Subject<any> = new Subject();
  public pastOrders: any[] = [];
  pastOrderLimit: number = 50;
  isLoadingOrders: boolean = false;
  clinic: any;
  clinic_name: string;
  clinic_id: string;
  clinic_province: string;
  clinic_cutoff_day: string;
  clinic_cutoff_time: string;
  email: string;
  status: string = 'Ready To Submit';
  view: string = 'Prescriptions';
  showInjDate = false;
  injectiondate: any = null;

  batch: any[] = [];
  doctor_batch: any;

  eylea_pfs_count: number;
  eylea_vial_count: number;
  ozurdex_count: number;
  avastin_count: number;
  lucentis_pfs_count: number;
  lucentis_vial_count: number;
  clindamycin_pfs_count: number;
  dexamethasone_pfs_count: number;
  ocuflox_count: number;
  beovu_count: number;
  triesence_count: number;
  vabysmo_count: number;
  total_count: number;

  notes: string = '';

  searchTerm: string = '';

  @ViewChild(Content)
  content: Content;

  suppliesList: any[] = [];
  suppliesOrderList: any[] = [];
  doctorSuppliesList: any[] = [];

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private readonly auth: AuthProvider,
    public database: DatabaseProvider,
    public alertCtrl: AlertController,
    public toastCtrl: ToastController,
    public modalCtrl: ModalController,
    private afs: AngularFirestore,
    private storage: Storage,
    private afStorage: AngularFireStorage,
    private loadingCtrl: LoadingController,
    public zone: NgZone,
    private pdf: PdfProvider,
    private orderService: OrderProvider,
    private utility: UtilityProvider,
    private el: ElementRef
  ) {
    this.auth.user
    .takeUntil(this.ngUnsubscribe)
    .subscribe(user => {
      console.log(user);
      this.email = user.email;
      this.clinic_name = user.clinic_name;
      this.clinic_id = user.clinic_id;
      this.clinic_province = user.clinic_province;
      this.database.getClinic(this.clinic_id)
        .valueChanges()
        .takeUntil(this.ngUnsubscribe)
        .subscribe((clinic) => {
          if (clinic) {
            this.clinic = clinic;
            this.clinic_cutoff_day = this.utility.getDayString(this.clinic.cutoff_day);
            this.clinic_cutoff_time = this.utility.getTimeString(this.clinic.cutoff_time);
            console.log('Cutoff: ', this.clinic_cutoff_day, this.clinic_cutoff_time);
          }
        });

      // this.database
      // .getDefaultSuppliesByClinic(this.clinic_id)
      // .snapshotChanges()
      // .map(actions => {
      //   return actions.map(a => {
      //     const data = a.payload.doc.data() as any;
      //     data.id = a.payload.doc.id;
      //     return data;
      //   });
      // })
      // .pipe(take(1))
      // .takeUntil(this.ngUnsubscribe)
      // .subscribe(async supplies => {
      //   this.suppliesList = supplies;
      //   this.suppliesOrderList = JSON.parse(JSON.stringify(supplies));
  
      // })
      
        this.getPrescriptionsNew();
      //this.getPrescriptions();
    });
  }

  ngOnDestroy() {
    console.log('Leave order and destroy subscriptions');
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  public formatDate(date) {
    let myMoment: moment.Moment;
    if (date && date.seconds) {
      myMoment = moment.unix(date.seconds);
    } else {
      myMoment = moment(date);
    }
    return myMoment.format("YYYY MMM DD, h:mm A");
  }

  openPrescriptionImage(imageUrl) {
    window.open(imageUrl, '_blank');
  }

  openOrderDetailsPage(order) {
    this.navCtrl.push(OrderDetailsPage, {"order": order});
  }

  public async getPrescriptionsNew()  {
    console.log('call rx query', this.clinic_id)
    this.doctorSuppliesList = [];
    this.database.getPrescriptionBatchByClinicAndUser(this.clinic_id, this.email, 'doctor_id', 'asc').valueChanges()
    .takeUntil(this.ngUnsubscribe)
    .subscribe(async rxarray => {
      console.log('rx: ', rxarray)
      let totalrx = rxarray;
      this.batch = rxarray;
      let type = 'Eylea PFS';
      this.eylea_pfs_count = totalrx.filter(t => t.medication[0].name === type && t.eye === 'OS').length + totalrx.filter(t => t.medication[0].name === type && t.eye === 'OD').length + (totalrx.filter(t => t.medication[0].name === type && t.eye === 'OU').length) * 2;
      type = 'Eylea vial';
      this.eylea_vial_count = totalrx.filter(t => t.medication[0].name === type && t.eye === 'OS').length + totalrx.filter(t => t.medication[0].name === type && t.eye === 'OD').length + (totalrx.filter(t => t.medication[0].name === type && t.eye === 'OU').length) * 2;
      type = 'Ozurdex';
      this.ozurdex_count = totalrx.filter(t => t.medication[0].name === type && t.eye === 'OS').length + totalrx.filter(t => t.medication[0].name === type && t.eye === 'OD').length + (totalrx.filter(t => t.medication[0].name === type && t.eye === 'OU').length) * 2;
      type = 'Avastin';
      this.avastin_count = totalrx.filter(t => t.medication[0].name === type && t.eye === 'OS').length + totalrx.filter(t => t.medication[0].name === type && t.eye === 'OD').length + (totalrx.filter(t => t.medication[0].name === type && t.eye === 'OU').length) * 2;
      type = 'Lucentis PFS';
      this.lucentis_pfs_count = totalrx.filter(t => t.medication[0].name === type && t.eye === 'OS').length + totalrx.filter(t => t.medication[0].name === type && t.eye === 'OD').length + (totalrx.filter(t => t.medication[0].name === type && t.eye === 'OU').length) * 2;
      type = 'Lucentis vial';
      this.lucentis_vial_count = totalrx.filter(t => t.medication[0].name === type && t.eye === 'OS').length + totalrx.filter(t => t.medication[0].name === type && t.eye === 'OD').length + (totalrx.filter(t => t.medication[0].name === type && t.eye === 'OU').length) * 2;
      type = 'Clindamycin PFS';
      this.clindamycin_pfs_count = totalrx.filter(t => t.medication[0].name === type && t.eye === 'OS').length + totalrx.filter(t => t.medication[0].name === type && t.eye === 'OD').length + (totalrx.filter(t => t.medication[0].name === type && t.eye === 'OU').length) * 2;
      type = 'Dexamethasone PFS';
      this.dexamethasone_pfs_count = totalrx.filter(t => t.medication[0].name === type && t.eye === 'OS').length + totalrx.filter(t => t.medication[0].name === type && t.eye === 'OD').length + (totalrx.filter(t => t.medication[0].name === type && t.eye === 'OU').length) * 2;
      type = 'Ocuflox';
      this.ocuflox_count = totalrx.filter(t => t.medication[0].name === type && t.eye === 'OS').length + totalrx.filter(t => t.medication[0].name === type && t.eye === 'OD').length + (totalrx.filter(t => t.medication[0].name === type && t.eye === 'OU').length) * 2;
      type = 'Beovu';
      this.beovu_count = totalrx.filter(t => t.medication[0].name === type && t.eye === 'OS').length + totalrx.filter(t => t.medication[0].name === type && t.eye === 'OD').length + (totalrx.filter(t => t.medication[0].name === type && t.eye === 'OU').length) * 2;
      type = 'Triesence';
      this.triesence_count = totalrx.filter(t => t.medication[0].name === type && t.eye === 'OS').length + totalrx.filter(t => t.medication[0].name === type && t.eye === 'OD').length + (totalrx.filter(t => t.medication[0].name === type && t.eye === 'OU').length) * 2;
      type = 'Vabysmo';
      this.vabysmo_count = totalrx.filter(t => t.medication[0].name === type && t.eye === 'OS').length + totalrx.filter(t => t.medication[0].name === type && t.eye === 'OD').length + (totalrx.filter(t => t.medication[0].name === type && t.eye === 'OU').length) * 2;

      this.total_count = this.eylea_pfs_count + this.eylea_vial_count + this.ozurdex_count + this.avastin_count + this.lucentis_pfs_count + this.lucentis_vial_count + this.clindamycin_pfs_count + this.dexamethasone_pfs_count + this.ocuflox_count + this.beovu_count + this.triesence_count + this.vabysmo_count;

      const doctors = this.batch.filter((doctor, i, arr) => arr.findIndex(t => t.doctor_id === doctor.doctor_id) === i).map(obj => obj.doctor);
      console.log('Doctors to get supplies for: ', doctors)
      this.doctorSuppliesList = [];
      await this.utility.asyncForEach(doctors, async (doctor) => {
       // console.log(doc);
       this.database.getDefaultSuppliesByDoctor(doctor.id)
        .valueChanges()
        .takeUntil(this.ngUnsubscribe)
        .subscribe(supplies => {
          const newDocSupply = { doctor: {}, supplies: [] }
          newDocSupply.doctor = doctor;
          newDocSupply.supplies = supplies;
          this.doctorSuppliesList.push(newDocSupply);
        })
      });
    });
  }

  getPastOrders(lastElement: any) {
    this.isLoadingOrders = true;
    this.afs.collection(`clinics/${this.clinic_id}/orders`, ref => {
      let query = ref.orderBy("createdAt", "desc").limit(this.pastOrderLimit);
      if (lastElement)
        query = query.startAfter(lastElement);
      return query;
    }).snapshotChanges()
      .map(actions => {
        return actions.map(a => {
          const data = a.payload.doc.data() as any;
          data.id = a.payload.doc.id;
          return data;
        });
      })
      .pipe(take(1))
      .subscribe((new_orders) => {
        this.pastOrders = [...this.pastOrders, ...new_orders];
        this.isLoadingOrders = false;
      });
  }

  onScroll(scrollEvent: any) {
    if (scrollEvent.target.scrollTop + scrollEvent.target.clientHeight >= scrollEvent.target.scrollHeight && !this.isLoadingOrders) {
      console.log("end");
      this.getPastOrders(this.pastOrders[this.pastOrders.length - 1].createdAt)
    }
  }

  segmentChanged(ev) {
    if (status === 'Ready To Submit') {
      this.getPrescriptionsNew();
    } else {
      this.getPastOrders(this.pastOrders[this.pastOrders.length - 1]);
    }
  }

  async viewChanged(ev) {
      this.view = ev.value;
  }

  submitOrder() {
    console.log('Doctor Supplies: ',       this.doctorSuppliesList)
    let confirm = this.alertCtrl.create({
      title: "Submit To Sentrex",
      message:
        "Are you sure you would like to submit this to Sentrex?",
      buttons: [
        {
          text: "No",
          handler: () => {
          }
        },
        {
          text: "Yes",
          handler: async () => {
            console.log("Start save order");
            const loading = this.loadingCtrl.create({});
            loading.present();

            let batchRx: any[] = [];
            const doctors = this.batch.filter((doctor, i, arr) => arr.findIndex(t => t.doctor_id === doctor.doctor_id) === i).map(obj => obj.doctor);
            
            const start = async () => {
              await this.utility.asyncForEach(doctors, async (doctor) => {     
                console.log("Write Rx Batches");        
                batchRx.push(
                  {
                    order_batch: `${doctor.id}_${doctor.last_name}`,
                    signature: doctor.signature,
                    rx: this.batch.filter(rx => rx.doctor_id === doctor.id)
                  }
                )
              });
            }
            start();

            let order = {};
            const newClinicOrderNumber = await this.database.getUniqueClinicOrderNumber(this.clinic_id);
            const newMasterOrderNumber = await this.database.getUniqueMasterOrderNumber();

            const order_number = `ORD${this.utility.pad(newClinicOrderNumber, 5, '0')}`;
            const order_number_master = `ORD${this.utility.pad(newMasterOrderNumber, 9, '0')}`;
            
            order['order_number'] = order_number;
            order['order_number_master'] = order_number_master;

            order['email'] = this.email;
            order['clinic_id'] = this.clinic_id;
            order['clinic_name'] = this.clinic_name;
            order['clinic_province'] = this.clinic_province;
            order['Eylea_PFS'] = this.eylea_pfs_count;
            order['Eylea_vial'] = this.eylea_vial_count;
            order['Lucentis_PFS'] = this.lucentis_pfs_count;
            order['Lucentis_vial'] = this.lucentis_vial_count;
            order['Ozurdex'] = this.ozurdex_count;
            order['Avastin'] = this.avastin_count;
            order['Clindamycin_PFS'] = this.clindamycin_pfs_count;
            order['Dexamethasone_PFS'] = this.dexamethasone_pfs_count;
            order['Ocuflox'] = this.ocuflox_count;
            order['Beovu'] = this.beovu_count;
            order['Triesence'] = this.triesence_count;
            order['Vabysmo'] = this.vabysmo_count;
            order['Total'] = this.total_count;
            order['rx'] = batchRx;
            order['type'] = 'rx';
            order['note'] = this.notes;
            order['email'] = this.email;
            order['software_version'] = ENV.VERSION;
            const filepath = await this.pdf.createOrderPDF(this.clinic, batchRx, this.notes, [], this.doctorSuppliesList, null, order['order_number']);
            order['order_file'] = filepath;
            console.log("before for each")
            await order['rx'].forEach(async (batch) => {
              console.log('Post Order Creation Filter: ', batch.order_batch);
              await batch.rx.forEach((rx) => {
                console.log('rx of batch pre: ', rx);
                rx.doctor.signature = null;
                console.log('rx of batch post: ', rx);
              })
            })
            console.log("after for each")
            console.log('Order: ', order)
            this.database.saveOrder(order, true).then((res) => {
              loading.dismiss();
              const finishedToast = this.toastCtrl.create({
                message: 'Your order was submitted.  You will be directed back to the patient list shortly.',
                duration: 3000,
                position: 'middle'
              });
              finishedToast.present();
              finishedToast.onDidDismiss(() => {
                this.navCtrl.setRoot(PatientsPage);
                // window.location.reload();
              });
            })
            .catch((err) => {
              loading.dismiss();
              const finishedToast = this.toastCtrl.create({
                message: 'There was a problem submitting this order - please try again.  If this persists, please contact Sentrex for assistance.',
                duration: 5000,
                position: 'middle'
              });
              finishedToast.present();
            })
          }
        }
      ]
    });
    confirm.present();
  }

  clearOrder() {
    let confirm = this.alertCtrl.create({
      title: "Delete Order",
      message:
        "Are you sure you want to delete this order? <strong>You can't recover a deleted order!</strong>",
      buttons: [
        {
          text: "No",
          handler: () => {
          }
        },
        {
          text: "Yes",
          handler: () => {
            this.database.deletePrescriptionBatchByClinic(this.clinic_id).then(() => {

            })
            // this.storage.remove('RetinaOrderBatch').then(() => {
            //   this.batch = null;

            //   this.eylea_pfs_count = 0;
            //   this.eylea_vial_count = 0;
            //   this.lucentis_pfs_count = 0;
            //   this.lucentis_vial_count = 0;
            //   this.ozurdex_count = 0;
            //   this.avastin_count = 0;
            //   this.dexamethasone_pfs_count = 0;
            //   this.clindamycin_pfs_count = 0;
            //   this.ocuflox_count = 0;
            //   this.total_count = 0;
            // });
          }
        }
      ]
    });
    confirm.present();
  }

  // toggleInjDate() {
  //   if (this.showInjDate === false) {
  //     this.injectiondate = moment().format('YYYY-MM-DD');
  //     this.showInjDate = true;
  //   } else {
  //     this.injectiondate = null;
  //     this.showInjDate = false;
  //   }
  // }

  async deleteRx(rx) {
    let confirm = this.alertCtrl.create({
      title: "Delete Rx",
      message:
        "Are you sure you want to delete this Rx?",
      buttons: [
        {
          text: "No",
          handler: () => {
          }
        },
        {
          text: "Yes",
          handler: async () => {
            console.log('start delete');
            await this.database.deletePrescription(rx.rx_id);
            console.log('end delete');
          }
        }
      ]
    });
    confirm.present();
  }

  createClinicOrderNumber(number: number) {
    return "ORD" + ("0000" + number).slice(-5);
  }

  createMasterOrderNumber(number: number) {
    return "ORD" + ("0000" + number).slice(-5);
  }

  viewRx(url) {
    window.open(url, '_blank');
  }

  openSignaturePad(doctorbatch_id) {
    let pad = this.modalCtrl.create(SignatureModal, {id: doctorbatch_id}, { cssClass: "signature-modal" });
    pad.onDidDismiss((data) => {
      
    });
    pad.present();
  }

  editPatientData(patient: any, rx_id) {
    this.navCtrl.push(PatientAddPage, { patient: patient, isOrder: true, rxId: rx_id }).then(() => {
      this.navCtrl.getActive().onDidDismiss(() => this.getPrescriptionsNew())
    });
  }

  editDrugData(rx: any) {
    this.navCtrl.push(PatientBatchPage, {rx: rx, patientdata: rx.patient}).then(() => {
      this.navCtrl.getActive().onDidDismiss(() => this.getPrescriptionsNew())
    });
  }

  deleteSupplies(supply) {
    let confirm = this.alertCtrl.create({
      title: "Delete Supplies",
      message:
        "Are you sure you want to delete this from the order?<br/><br/><strong>Please note: </strong>This will only remove this from the current order.  To permanently remove this as a default supply on future orders, go to Supplies > Set Default Supplies for Rx Orders.",
      buttons: [
        {
          text: "No",
          handler: () => {}
        },
        {
          text: "Yes",
          handler: () => {
            const index: number = this.suppliesOrderList.indexOf(supply, 0);
            if (index > -1) {
              this.suppliesOrderList.splice(index, 1);
            }
        }
    }
    ]
    });
    confirm.present();
  }

  deleteDoctorSupplies(doctorIdx, supply)  {
    let confirm = this.alertCtrl.create({
      title: "Delete Supplies",
      message:
        "Are you sure you want to delete this from the order?<br/><br/><strong>Please note: </strong>This will only remove this from the current order.  To permanently remove this as a default supply on future orders, go to Supplies > Set Default Supplies for Rx Orders.",
      buttons: [
        {
          text: "No",
          handler: () => {}
        },
        {
          text: "Yes",
          handler: () => {
            
            const index: number = this.doctorSuppliesList[doctorIdx].supplies.indexOf(supply, 0);
            console.log('Doc Supply Delete',this.doctorSuppliesList[doctorIdx].supplies, supply, index)
            if (index > -1) { 
              this.doctorSuppliesList[doctorIdx].supplies.splice(index, 1);
              if (this.doctorSuppliesList[doctorIdx].supplies.length === 0) this.doctorSuppliesList.splice(doctorIdx, 1);
            } 
        }
    }
    ]
    });
    confirm.present();
  }
}


@Component({
  selector: "page-signature-pad",
  template: "<ion-toolbar color=\"sentrex_blue\" style='min-height: 45px;'><ion-title>Sign Here</ion-title></ion-toolbar>"+
    "<signature-pad  #sigpad1 style=\"border-bottom: 1px dashed #000;\"  [options]=\"signaturePadOptions\"\n (onBeginEvent)=\"drawStart()\" (onEndEvent)=\"drawComplete()\"></signature-pad>" +
    "<ion-row>" +
    "<ion-col col-4><button block small ion-button color=\"dark\" (click)='clearPad()'>Clear</button></ion-col>"+
    "<ion-col col-4><button block small ion-button color=\"danger\" (click)='closeSignatureModal()'>Cancel</button></ion-col>"+
    "<ion-col col-4><button block small ion-button color=\"sentrex_blue\" (click)=\"submitSignature(batch_id)\" >Submit</button></ion-col>" +
    "</ion-row>"
})
export class SignatureModal {
  @ViewChild('sigpad1') signaturePad: SignaturePad;
  signature: any;
  isDrawing = false;
  batch_id: string;
  viewCtrl: ViewController;
  storage: Storage;

  private signaturePadOptions: Object = {
    minWidth: 2,
    canvasWidth: 500,
    canvasHeight: 150,
    backgroundColor: "#ffffff",
    penColor: "#6f6f6f"
  };

  constructor(params: NavParams, viewCtrl: ViewController, storage: Storage) {
    this.batch_id = params.get("id");
    this.viewCtrl = viewCtrl;
    this.storage = storage;
  }

  closeSignatureModal() {
    this.viewCtrl.dismiss();
  }

  clearPad() {
    this.signaturePad.clear();
  }

  submitSignature() {
    this.signature = this.signaturePad.toDataURL();
    this.viewCtrl.dismiss();
    // this.storage.get("RetinaOrderBatch").then((order) => {
    //   for ( let doctor of order) {
    //     if (doctor['order_batch'] == this.batch_id) {
    //       doctor['signature'] = this.signature;
    //     }
    //   }
    //   this.storage.set("RetinaOrderBatch", order).then(() => this.viewCtrl.dismiss(order));
    // });
  }

  drawComplete() {
    this.isDrawing = false;
  }

  drawStart() {
    this.isDrawing = true;
  }
}


// WEBPACK FOOTER //
// ./src/pages/orders/orders.ts